export default "__VITE_ASSET__eb3ec0b9__"